import Market from './Market';
import MarketFactory from './MarketFactory';
import DomainRegistry from '@/creditflowresearch/domain/DomainRegistry';

DomainRegistry.register(async (container, data) => {
  if (data?.markets?.length) {
    Market.initialize(data.markets, MarketFactory.createFromData);
  }
});

export { default } from './Market';
export { default as Market } from './Market';
export { default as MarketFactory } from './MarketFactory';
export { default as UsMarket } from './entities/UsMarket';
export { default as EuropeanMarket } from './entities/EuropeanMarket';
export { default as ApacMarket } from './entities/ApacMarket';
export { default as EmergingMarket } from './entities/EmergingMarket';
export { MarketName } from './types/MarketType';
export { MarketSegment } from './types/MarketSegment';
export * from './constants';
